import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import styled from 'styled-components'
import LogoRanking from '@/images/logo-ranking.svg'
import Logo2021 from '@/images/logo-2021.svg'

const StHero = styled.div`
  position: relative;
  padding-top: 8rem;
  text-align: center;
  min-height: 40vh;
  @media (orientation: portrait) {
    padding: 1rem;
    margin-top: 5rem;
  }
  .cols {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (orientation: portrait) {
      grid-template-columns: 1fr;
    }
    .pos2021-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      z-index: -1;
      @media (orientation: portrait) {
      }
    }
    .col02 {
      margin-left: -20%;
      @media (orientation: portrait) {
        margin-left: inherit;
      }
    }
  }
  .max-w-screen-xs {
    max-width: 450px;
  }
`

const Hero = () => {
  return (
    <StHero>
      <div className="content">
        <div className="mx-auto max-w-screen-sm md:max-w-screen-xl sm:p-8 p-3 relative">
          <div className="cols">
            <div className="col01">
              <h1 className="leading-none text-6xl m-0">
                <img
                  src={LogoRanking}
                  alt="Ranking de las Universidades 2021"
                  className="block logo1"
                />
              </h1>

              <p className="text-2xl leading-tight mt-0 text-left max-w-screen-xs pt-8 pb-8 "></p>
            </div>
            <div className="col02">
              <StaticImage
                className="joven"
                src="../../images/joven-2021.png"
                alt="Joven 2021"
              />
            </div>
            <div className="pos2021-bg">
              <img src={Logo2021} className="pos2021" />
            </div>
          </div>
        </div>
      </div>
    </StHero>
  )
}

export default Hero
